<template>
  <v-popover
    trigger="hover"
    class="cursor-pointer outline-none"
  >
    <Info />
    <slot slot="popover" />
  </v-popover>
</template>

<script>
import Info from './icons/Info.vue';

export default {
  name: 'BaseInfoTooltip',
  components: {
    Info,
  },
};
</script>

<style lang="scss">
.trigger {
  outline: none;
}

.tooltip-inner {
  ul {
    list-style-type: none;
    padding: 0;

    li {
      position: relative;

      &::before {
        content: '- ';
      }
    };
  }
  background: rgba(48, 67, 92, 0.93);
  color: #FFF;
  padding: 18px 24px;
  border-radius: 4px;
}
</style>
